export function detectIE(returnVersion) {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf('MSIE ');
    var trident = 0; 
    var rv = 0;
    
    if (msie > 0) {
        /* IE 10 or older */
        return returnVersion ? parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10) : true;
    }

    trident = ua.indexOf('Trident/');
    if (trident > 0) {
        /* IE 11 */
        rv = ua.indexOf('rv:');
        
        return returnVersion ? parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10) : true;
    }

    return false;
}